const initialState = {
	unlockedMedias: [],
};

const getUniqueUnlockMedias = (state, action) => {
	let newData = state ?? [];
	if (!newData.find((n) => n.mediaId === action.mediaId)) {
		return [...newData, action];
	}

	newData = newData.map((s) => (action.mediaId === s.mediaId ? action : s));
	return newData;
};

const restrictionReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_UNLOCKED_MEDIA':
			return {
				...state,
				unlockedMedias: getUniqueUnlockMedias(state.unlockedMedias, action.unlockedMedia),
			};
		case 'SET_UNLOCKED_MEDIAS':
			return {
				...state,
				unlockedMedias: action.unlockedMedias,
			};
		default:
			return state;
	}
};

export default restrictionReducer;
